import CompanyStatsRow from './CompanyStatsRow';

interface ICompanyStatsBodyProps {
  companyStats: CompanyStats | null;
}
const CompanyStatsBody = ({ companyStats }: ICompanyStatsBodyProps) => {
  // todo, create statTable component for insert loader
  // if (companyStatsStatusPending) return <IndividualCircularLoader size={200} />;

  return (
    <tbody>
      {companyStats?.map((row) => (
        <CompanyStatsRow key={row.idIri} row={row} />
      ))}
    </tbody>
  );
};

export default CompanyStatsBody;
